import { Collection, Model } from 'web-mojo';

class PaymentProcessor extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/payments/processor'
        });
    }

    nameOrId() {
        return this.get('processor_type') || this.get('id');
    }
}

class PaymentProcessorList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: PaymentProcessor,
            endpoint: '/api/payments/processor',
            ...options
        });
    }
}

PaymentProcessor.EDIT_FORM = {
    title: 'Payment Processor',
    fields: [
        { name: 'processor_type', type: 'select', label: 'Processor Type', columns: 6,
          options: [
              { label: 'Stripe',           value: 'stripe' },
              { label: 'Sandbox (testing)', value: 'sandbox' },
          ]},
        {
            name: 'metadata.currency',
            type: 'text',
            label: 'Currency',
            value: "USD",
            columns: 6,
        },
        { name: 'is_active',      type: 'checkbox', label: 'Active',          columns: 6 },
        { name: 'is_default',     type: 'checkbox', label: 'Set as Default',  columns: 6 },
    ]
};

export { PaymentProcessor, PaymentProcessorList };
